import React, { useState } from 'react'

const alertStyle = {
  top: '6px',
  right: 0,
  border: 'none',
  color: 'var(--med-grey)'
}

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}

export default function DeemedCompleteAlert({ packageId }) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  async function handleDismiss() {
    setDismissed(true)
    try {
      await fetch(`/api/packages/${packageId}/1120b/dismiss_alert`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Content-Type': 'application/json',
        },
      })
    } catch (e) {
      // Optimistic dismiss — server persistence is best-effort. If this fails,
      // the alert will reappear on next load (stored in metadata.plugins.1120b.alert_dismissed_by).
      console.warn('DeemedCompleteAlert: failed to persist dismissal', e)
    }
  }

  return (
    <div className="deemed-complete-alert dome-relative">
      <div className="deemed-complete-alert__body dome-p3 dome-padding6-12 dome-rounded-border dome-bg-accent">
        According to <span className='dome-color-aqua dome-text-w500'>Local Law 58 of 2026</span>, the acknowledgment deadline has passed. Per law, this application automatically moves into the 45-day board review.
      </div>
      <button
        type="button"
        className="deemed-complete-alert__dismiss dome-absolute"
        style={alertStyle}
        aria-label="Dismiss"
        onClick={handleDismiss}
      >
        <i className='fal fa-xmark dome-p4' />
      </button>
    </div>
  )
}
